// extracted by mini-css-extract-plugin
export default {"root":"CaptionsPanel_root__2kAGW","captionListArea":"CaptionsPanel_captionListArea__zDdEZ","captionList":"CaptionsPanel_captionList__7aA4n"};